import { useMemo } from 'react'
import { Loadable } from '../common'
import { useNubsQuery } from './Nubs.state'
import Nub from '../common/NubsUpload/Nub'
import { ChallengeDescriptionContainer } from './ChallengeView.style'

const ChallengeDescription = (props) => {
    const { id, containerRef, preview } = props
    const [collection, , isFetching] = useNubsQuery(id)
    const { nubs = [] } = collection || {}
    const descriptionNub = useMemo(() => {
        return nubs.find(nub => {
            const { chunk } = nub
            // HTML description can contains iframe in the body.
            // In this case, content is embeddable and needs to be serve from an iframe
            // when it starts with script, iframe, or contains div tags.
            const isEmbeddable = (chunk || '').match(/^<script|^<iframe|<div/)
            return chunk && !isEmbeddable
        })
    }, [nubs])

    return (
        <ChallengeDescriptionContainer>
            <Loadable loading={isFetching}>
                {
                    descriptionNub
                        // If challenge has both nub description and preview, just show the nub description in the card
                        // If challenge has HTML nub description just show that in the card
                        ? <Nub nub={descriptionNub} containerRef={containerRef} />

                        // If challenge has no nub description but has preview, show preview
                        : preview
                            ? <Nub nub={{ chunk: preview }} containerRef={containerRef} className='nubs__item--preview' />
                            : null
                }
            </Loadable>
        </ChallengeDescriptionContainer>
    )
}

export default ChallengeDescription